import React from 'react'
import { useStyles } from './ErrorFallback.styles'

interface FallbackProps {
  error: Error
  frontend_track_id?: string
}

export const ErrorFallback: React.FC<FallbackProps> = ({
  frontend_track_id,
}) => {
  const { classes } = useStyles()
  return (
    <div data-testid="errorFallback" className={classes.main} role="alert">
      <h2>Something went wrong</h2>
      {frontend_track_id && <p>Track ID: {frontend_track_id}</p>}
    </div>
  )
}
